import React, { Fragment, FunctionComponent } from "react";

import { Link, useNavigate, useLocation } from "react-router-dom";
import isBrowserContext from "helpers/isBrowserContext";
import AppLocationState from "app/models/location-state.interface";
import relativeUrl from "helpers/relativeUrl";

const Anchor: FunctionComponent<any> = (props) => {
    let link = undefined;


    switch (typeof props.to) {
        case "string":
            link = relativeUrl(props.to);
            break;
        case "object":
            link = relativeUrl(props.to?._url);
            break;
        default:
            link = undefined;
            break;
    }

    const navigate = useNavigate();
    const location = useLocation();

    if (!link || (link && link.startsWith("umb://"))) {
        return <div className={props.className}>{props.children}</div>;
    }

    if (isBrowserContext()) {
        const host = `${window.location.protocol}//${window.location.host}`;

        // Making an absolute url to a relative url, if same domain.
        if (window.location.href.indexOf(host) > -1) {
            link = link.replace(host, "");
        }
    }

    const onLinkClick = () => {
        if (typeof props.onClick !== "undefined") {
            try {
                props.onClick();
            } catch {}
        }

        // Save scrollY state
        if (isBrowserContext()) {
            navigate(location.pathname, {
                replace: true,
                state: {
                    ...(location.state as any),
                    scrollY: window.scrollY,
                },
            });
        }
    };

    return (
        <Fragment>
            {(typeof link === "string" && link.startsWith("http")) || props.target === "_blank" ? (
                <a
                    style={props.style}
                    className={props.className}
                    href={link}
                    rel="noreferrer noopener"
                    target={props.target}
                >
                    {props.children}
                    
                </a>
            ) : (
                <Link
                    style={props.style}
                    className={props.className}
                    to={link}
                    onClick={() => onLinkClick()}
                >
                    {props.children}
                </Link>
            )}
        </Fragment>
    );
};

export default Anchor;
